import type { ReactNode } from 'react';

export const symbol_person_apron: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M373.5-524.5Q330-568 330-631t43.5-106.5Q417-781 480-781t106.5 43.5Q630-694 630-631t-43.5 106.5Q543-481 480-481t-106.5-43.5ZM160-220v-34q0-35 18-63.5t50-42.5q60-27 123-43.5T480-420q66 0 128.5 17T731-360q32 14 50.5 42.5T800-254v34q0 25-17.5 42.5T740-160H220q-25 0-42.5-17.5T160-220Zm384-347q26-26 26-64t-26-64q-26-26-64-26t-64 26q-26 26-26 64t26 64q26 26 64 26t64-26Zm96 234v113h100v-34q0-17-9-30.5T707-306q-17-8-33.5-14.5T640-333Zm-260-17v60h200v-60q-25-5-49.5-7.5T480-360q-26 0-50.5 2.5T380-350ZM220-220h100v-114q-17 6-34 13t-34 15q-15 8-23.5 21.5T220-254v34Zm420 0H320h320ZM480-631Z"
		/>
	</svg>
);
